<div class="container">
    <h3>Mentions Légales</h3>
    <p>
        Ce site est géré par une communauté. Les informations suivantes sont fournies conformément à la loi applicable :
    </p>
    <ul>
        <li><strong>Nom de la communauté :</strong> Lupino</li>
        <li><strong>Email de contact :</strong>  <a href="mailto:marine.deruelle@laposte.net">marine.deruelle&#64;laposte.net</a>.
    </ul>
    <p>
        Le responsable du traitement des données est la personne en charge de cette communauté. Si vous avez des questions, n'hésitez pas à nous contacter.
    </p>
</div>